<template>
  <transition name="modal">
    <div class="modal-mask" @click="close" v-show="show">
      <div class="modal-container" @click.stop>
        <div class="modal-header">
          <span class="modal-title">Share</span>
          <button class="modal-default-button close" @click="savePost()">
            Close
          </button>
        </div>
        <div class="modal-body">
          <label class="form-label">
            <div class="title">Copy URL</div>
            <div
              class="MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl"
            >
              <input
                aria-invalid="false"
                type="text"
                class="MuiInputBase-input MuiInput-input"
                value="https://www.askaway.cc"
              />
            </div>
          </label>
        </div>
        <div class="modal-footer">
          <div class="title">Social</div>
          <div class="socialContainer">
            <button aria-label="twitter" @click="shareTwitter">
              <img src="../assets/twitter-black.svg" alt="Twitter Logo">
            </button>
            <button aria-label="facebook" @click="shareFacebook">
              <img src="../assets/facebook-black.svg" alt="Facebook Logo">
            </button>
            <button aria-label="linkedin" @click="shareLinkedIn">
              <img src="../assets/linkedin-black.svg" alt="LinkedIn Logo">
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Vue from "vue";
export default Vue.component("modal", {
  template: "#modal-template",
  props: ["show"],
  data: function () {
    return {
      showModal: false,
      shareWindowWidth: 500,
      shareWindowHeight: 400,
      askawayUrl: 'https://www.askaway.cc',
    }
  },
  computed: {
    twitterShareLink: function () {
      return `https://twitter.com/intent/tweet?url=${encodeURI(this.askawayUrl)}&original_referer=${encodeURI(this.askawayUrl)}`
    },
    facebookShareLink: function () {
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURI(this.askawayUrl)}`
    },
    linkedInShareLink: function () {
      return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURI(this.askawayUrl)}`
    },
  },
  methods: {
    close: function() {
      this.$emit("close");
    },
    savePost: function() {
      this.close();
    },
    openShareWindow: function(shareLink) {
      window.open(
        shareLink ,
        'newwindow',
        'width=' + this.shareWindowWidth + ', height=' + this.shareWindowHeight + ', top=' + ((window.innerHeight - this.shareWindowHeight) / 2) + ', left=' + ((window.innerWidth - this.shareWindowWidth ) / 2));
    },
    shareTwitter: function() {
      this.openShareWindow(this.twitterShareLink)
    },
    shareFacebook: function() {
      this.openShareWindow(this.facebookShareLink)
    },
    shareLinkedIn: function() {
      this.openShareWindow(this.linkedInShareLink)
    },
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  box-sizing: border-box;
}

.MuiInputBase-input {
  font: inherit;
  color: currentColor;
  width: 100%;
  border: 0;
  height: 1.1875em;
  margin: 0;
  display: block;
  padding: 6px 0 7px;
  min-width: 0;
  background: none;
  box-sizing: content-box;
  animation-name: mui-auto-fill-cancel;
  -webkit-tap-highlight-color: transparent;
}

.MuiInputBase-root {
  color: #66646b;
  display: block;
  font-size: 18px;
  font-family: SofiaProRegular;
  line-height: 30px;
  padding-bottom: 9px;
  margin-top: 15px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.87);
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
}

.modal-container {
  width: 300px;
  width: 554px;
  height: 385px;
  margin: 200px auto 0;
  padding: 40px 60px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-container .socialContainer {
  text-align: left;
  margin-top: 1em;
}

.socialContainer button {
  border: 0;
  background-color: #fff;
  margin-right: 2em;
}

.modal-container .title {
  color: #9292a8;
  font-size: 14px;
  font-family: "SofiaProRegular";
  line-height: 14px;
  text-align: left;
}

.modal-footer {
  margin-top: 66px;
}

.modal-header .close {
  float: right;
  color: #66646b;
  font-size: 12px;
  font-family: "SofiaProBold";
  line-height: 20px;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  background-color: #fff;
  border-width: 0px;
  background: url(../assets/cross_sign.svg) no-repeat top right;
  padding-right: 3em;
  margin-top: 22px;
  margin-bottom: 22px;
}

.modal-header {
  height: 74px;
  margin-bottom: 2em;
}

.modal-title {
  float: left;
  color: #22272b;
  font-size: 48px;
  font-family: "SofiaProBold";
  height: 74px;
}

.modal-body {
  margin: 20px 0;
}

.text-right {
  text-align: right;
}

.form-label {
  display: block;
  margin-bottom: 1em;
}

.form-label > .form-control {
  margin-top: 0.5em;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.5em 1em;
  line-height: 1.5;
  border: 1px solid #ddd;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
